"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _CheckboxModule = _interopRequireDefault(require("./Checkbox.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var sizes = {
  sm: 16,
  default: 20
};

var Checkbox =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Checkbox, _React$Component);

  function Checkbox() {
    _classCallCheck(this, Checkbox);

    return _possibleConstructorReturn(this, _getPrototypeOf(Checkbox).apply(this, arguments));
  }

  _createClass(Checkbox, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isChecked = _this$props.isChecked,
          className = _this$props.className,
          labelText = _this$props.labelText,
          roundForm = _this$props.roundForm,
          size = _this$props.size,
          textColor = _this$props.textColor,
          disabled = _this$props.disabled,
          onChange = _this$props.onChange,
          attributes = _objectWithoutProperties(_this$props, ["isChecked", "className", "labelText", "roundForm", "size", "textColor", "disabled", "onChange"]);

      var classes = (0, _classnames.default)(_CheckboxModule.default.checkboxContainer, roundForm && _CheckboxModule.default.roundForm, disabled && _CheckboxModule.default.disabled, size === "sm" && _CheckboxModule.default.sm, className);

      var _size = sizes[size] || sizes.default;

      return _react.default.createElement("label", {
        className: classes
      }, _react.default.createElement("span", {
        className: _CheckboxModule.default.inputCheckbox,
        style: {
          width: _size,
          height: _size
        }
      }, _react.default.createElement("input", _extends({
        type: "checkbox",
        className: _CheckboxModule.default.checkboxInput,
        checked: isChecked,
        onChange: onChange,
        disabled: disabled
      }, attributes)), _react.default.createElement("div", {
        className: _CheckboxModule.default.checkboxSvgContainer
      }, _react.default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "8",
        height: "8",
        viewBox: "0 0 8 8",
        className: _CheckboxModule.default.inputCheckboxFlag
      }, _react.default.createElement("path", {
        id: "Rounded_Rectangle_1075_copy_38",
        "data-name": "Rounded Rectangle 1075 copy 38",
        className: "cls-1",
        d: "M793.833,3041.84l-4.967,6.98a0.128,0.128,0,0,1-.017.04,0.519,0.519,0,0,1-.73,0,0.163,0.163,0,0,1-.016-0.04l-1.967-1.96a0.5,0.5,0,0,1,.706-0.71l1.643,1.64,4.642-6.65A0.5,0.5,0,1,1,793.833,3041.84Z",
        transform: "translate(-786 -3041)"
      })))), labelText && _react.default.createElement("span", {
        style: {
          color: textColor
        },
        className: _CheckboxModule.default.checkboxLabel
      }, labelText));
    }
  }]);

  return Checkbox;
}(_react.default.Component);

Checkbox.propTypes = {
  isChecked: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  roundForm: _propTypes.default.bool,
  size: _propTypes.default.string,
  onChange: _propTypes.default.func
};
Checkbox.defaultProps = {
  isChecked: false,
  disabled: false,
  roundForm: false,
  labelText: "",
  size: ""
};
var _default = Checkbox;
exports.default = _default;